@if (
  (asset.type === 'image' &&
    (asset.version_data
      | assetVersionUrl
        : asset.version_data.uuid
        : asset.version_data['status']
        : asset.version_data.watermark_uuid
        : dimensions.width
        : true
        : asset.watermark_enabled
      | async)) ||
    preview;
  as imgSrc
) {
  <img [attr.data-picflow-hide]="true" [class.hovering]="hovering" [src]="imgSrc" alt="" />
}
@if (asset.type === 'video') {
  @if (asset | canDisplayAsset) {
    @if (isDesktop || asset.autoplay) {
      <app-video-viewer
        [class.hovering]="hovering"
        [videoData]="$any(asset.version_data.data)"
        [assetVersion]="asset.version_data"
        [asset]="asset"
        [uuid]="asset.version_data.uuid"
        [origin]="asset.version_data.asset_name"
        [poster]="
          asset.version_data
            | assetVersionUrl
              : asset.version_data.uuid
              : asset.version_data['status']
              : asset.version_data.watermark_uuid
              : dimensions.width
              : true
              : asset.watermark_enabled
            | async
        "
        [active]="(hovering || asset.autoplay) && !asset['tempUploadingPoster']"
        [showUi]="false"
        [handleUi]="false"
        [autoplay]="(hovering || asset.autoplay) && !asset['tempUploadingPoster']"
        [muted]="true"
        [allowUnmute]="isDesktop"
        [loop]="true"
        [targetWidth]="dimensions.width"
        [reportTimeChange]="true"
        #video
        (onTimeChange)="onTimeChange()"
      >
      </app-video-viewer>
      @if (video.status !== 'playing' && !asset['tempUploadingPoster']) {
        <div class="video-indicator" [class.loading]="video.status === 'loading'">
          <app-svg src="/assets/icons/play.svg"></app-svg>
        </div>
      }
    } @else {
      @if (
        asset.version_data
          | assetVersionUrl
            : asset.version_data.uuid
            : asset.version_data['status']
            : asset.version_data.watermark_uuid
            : dimensions.width
            : true
            : asset.watermark_enabled
          | async;
        as imgSrc
      ) {
        <img [attr.data-picflow-hide]="true" [class.hovering]="hovering" [src]="imgSrc" alt="" />
      }
      @if (!asset['tempUploadingPoster']) {
        <div class="video-indicator">
          <app-svg src="/assets/icons/play.svg"></app-svg>
        </div>
      }
    }
  } @else if (asset.version_data['status'] === 'failed') {
    @if (
      asset.version_data
        | assetVersionUrl
          : asset.version_data.uuid
          : asset.version_data['status']
          : asset.version_data.watermark_uuid
          : dimensions.width
          : true
          : asset.watermark_enabled
        | async;
      as imgSrc
    ) {
      <img [attr.data-picflow-hide]="true" [src]="imgSrc" alt="" />
    }
  }
}
@if (
  (gallery.watermark &&
    asset.watermark_enabled &&
    !asset.version_data.watermark_uuid &&
    asset.type === 'image' &&
    asset.version_data.status === 'completed') ||
  asset.version_data['status'] === 'pending'
) {
  <div class="asset-watermark-spinner">
    <app-loading-indicator [color]="'white'" [size]="'small'"></app-loading-indicator>
  </div>
}
@if (asset['tempUploadingPoster']) {
  <div class="asset-custom-poster-upload-spinner">
    <app-loading-indicator [color]="'white'" [size]="'small'"></app-loading-indicator>
  </div>
}

@if (
  isDesktop &&
  accessLevel !== 'view_only' &&
  (allowedAndEnabledFeedbackOptions?.includes('favourite') || allowedAndEnabledFeedbackOptions?.includes('status'))
) {
  @if (hovering) {
    <div class="feedback" [@feedback]>
      @if (allowedAndEnabledFeedbackOptions.includes('favourite')) {
        <button
          appButton
          name="toggle-like"
          location="asset-page-footer"
          color="dark-blur"
          shape="round"
          iconTextSpacing="0"
          appTooltip
          [tooltipHtmlContent]="favoritedUsersString$ | async"
          (onShow)="openFavoritedUsers()"
          spacing="1"
          height="-1"
          size="1"
          weight="bold"
          class="favorited-button"
          [class.favorited]="asset['is_liked']"
          [class.has-favorites]="asset['is_liked']"
          [hasIcon]="asset.likes > 0"
          (click)="toggleLike($event)"
          [iconButton]="asset.likes === 0"
          [class.active]="asset.is_liked"
        >
          @if (!asset['is_liked']) {
            <app-svg src="/assets/icons/heart-empty.svg" size="0"></app-svg>
          } @else {
            <app-svg src="/assets/icons/heart-filled.svg" size="0"></app-svg>
          }
          @if (asset.likes > 0) {
            <span>{{ asset.likes }}</span>
          }
        </button>
      }
      @if (allowedAndEnabledFeedbackOptions.includes('status')) {
        <app-asset-status-button
          [gallery]="gallery"
          [asset]="asset"
          [approvedAssetCount]="gallery.approval_limits && approvedAssetCount"
          [defaultColor]="'dark-blur'"
          [small]="true"
          [tiny]="true"
          (onSelectStatus)="updateAssetStatus($event)"
          location="layout-asset"
          (click)="statusClick($event)"
        ></app-asset-status-button>
      }
    </div>
  } @else if (
    (allowedAndEnabledFeedbackOptions.includes('favourite') && asset.likes > 0) ||
    (allowedAndEnabledFeedbackOptions.includes('status') && asset.status !== 'no_status')
  ) {
    <div class="feedback-hints-container" [@feedbackHints]>
      <div class="feedback-hints">
        @if (allowedAndEnabledFeedbackOptions.includes('favourite') && asset.likes > 0) {
          <div class="has-span" [class.red]="asset.is_liked">
            <app-svg src="/assets/icons/heart-filled.svg"></app-svg>
            <span>{{ asset.likes }}</span>
          </div>
        }
        @if (allowedAndEnabledFeedbackOptions.includes('status') && asset.status !== 'no_status') {
          <div class="{{ asset.status | assetStatusColor }} status-hint">
            <app-svg [src]="'/assets/icons/' + (asset.status | assetStatusIcon) + '.svg'"></app-svg>
            @if (asset.status === 'approved') {
              <div class="approved-white-bg"></div>
            }
          </div>
        }
      </div>
    </div>
  }
}
